import { render, staticRenderFns } from "./UpdateCreativeCarousel.vue?vue&type=template&id=49486f5a&scoped=true&"
import script from "./UpdateCreativeCarousel.vue?vue&type=script&lang=js&"
export * from "./UpdateCreativeCarousel.vue?vue&type=script&lang=js&"
import style0 from "./UpdateCreativeCarousel.vue?vue&type=style&index=0&id=49486f5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49486f5a",
  null
  
)

export default component.exports